/* eslint-disable jsx-a11y/alt-text */
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";


import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';
import { getSelectedLanguage } from "../../../store/Checkin/languageSlice";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const UpgradeConfirmationCard = ({ showModal, closeModal, onConfirm, resetTimerAndClosePopUp }) => {
  const timeLimit = 10;
  const navigate = useNavigate();
  const [currentCount, setCurrentCount] = useState(timeLimit);

  const closeModalPopUp = () => {
    resetTimerAndClosePopUp();
  };

  const dispatch = useDispatch();

  const progressOffset = Math.round(100 - (100 * currentCount) / timeLimit);
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
     }, []);


  return (
    <div className="modal" style={{ zIndex: "2" }}>
      <div className="modal-dialog modal-lg modal-top">
        <div className="modal-content modal-bg">
          <div className="modal-body">
            <div className="text-center">
              <div className="mt-30 modal-info">
                <h6>{t("Are you sure you want to add the selected package?")}</h6>
                <h6>{t("You will not be able to revert this if you confirm")}</h6>
              </div>
            </div>
            <div className="text-center mt-30">
              <button id="btn-upgradeconfcard-no"
                type="button"
                onClick={closeModalPopUp}
                className="btn modal-no-btn"
              >
                {t("No")}
              </button>
              <Link
                onClick={onConfirm}
                to={"/home-page"}
                className="btn modal-yes-btn"
              >
                {t("Confirm")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeConfirmationCard;
